window.dataLayer = window.dataLayer || [];
window.plyrInstances = window.plyrInstances || [];
window.SwymCallbacks = window.SwymCallbacks || [];

(function() {
  function analyticsEvents() {
    this.init = this._init;
    this.attachPlyrVideoEvents = this._attachPlyrVideoEvents;
  }
  
  analyticsEvents.prototype = Object.assign(analyticsEvents.prototype, {
    _init() {
      this._attachPlyrVideosEvents();
      this._attachProductEvents();
      this._attachProductPageEvents();
      this._attachWishlistEvents();
      this._attachScentSpaceEvents();
    },
    
    _attachProductEvents() {
      document.addEventListener('analytics_add_to_cart', (e) => {
        const analyticsEvent = e.detail.eventData.event;
        const data = e.detail.eventData.data;
        if (!event || !data) return;
        console.log('event', analyticsEvent, data);
        gtag('event', analyticsEvent, data);
      });  
    },
    
    _attachProductPageEvents() {
      if (!this._getPageType().includes('product')) return;
      this._attachGuideEvents();
      this._attachSectionEvents();
    },
  
    _attachCartPageEvents() {
      if (!this._getPageType().includes('cart')) return;
      const cartJSON = window.ShopifyCart;
      if (!cartJSON.item_count) return;
      let cartItemsAnalytics = cartJSON.items.map((item) => {
        return {
          item_id: item.sku,
          item_name: item.product_title,
          affiliation: "Shopify Store",
          coupon: item.discounts.join(','),
          discount: item.total_discount,
          item_brand: item.vendor,
          item_category: item.product_type,
          item_variant: item.variant_title,
          item_sku: item.sku,
          price: item.final_line_price,
          quantity: item.quantity
        }
      });
      
      gtag('event', 'view_cart', {
        currency: cartJSON.currency,
        value: cartJSON.total_price,
        items: cartItemsAnalytics
      });
      
    },
  
    _attachPlyrVideosEvents() {
      if (!window.plyrInstances.length) return;
  
      window.plyrInstances.forEach((plyrInstance) => {
        this._attachPlyrVideoEvents(plyrInstance);
      });
  
    },
  
    _attachGuideEvents() {
      const modalOpener = document.querySelector('modal-opener[data-modal*="#Guide"]');
      const modalDialog = document.querySelector('modal-dialog[id*="Guide"]');
      if (!modalOpener || !modalDialog) return;
  
      const title = modalOpener.dataset.guideTitle;
  
      modalDialog.addEventListener('show', () => {
        gtag('event', 'view_guide', {
          guide_title: title,
          page_url: `${window.location.origin}/products/${window.location.pathname.split('/products/')[1]}`
        });
      });
      
    },
  
    _attachSectionEvents() {
      const productHandle = window.location.pathname.split('/products/')[1].split('?')[0].split('#')[0];
  
      this._fetchProductByHandle(productHandle).then((productJSON) => {
        if (!productJSON) return;
        const productSections = document.querySelectorAll('.shopify-section.shopify-product-section');
        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            const sectionName  = [...entry.target.classList].find((cl) => cl.includes('shopify-product-section-title--')).replace('shopify-product-section-title--', '');
            if (entry.isIntersecting) {
              gtag('event', 'section_scrolled', {
                page_type: 'product_page',
                section_name: sectionName,
                product_id: productJSON.id,
                product_handle: productJSON.handle,
                product_title: productJSON.title,
                product_url: `${window.location.origin}/products/${productJSON.handle}`,
                timestamp: new Date().toISOString()
              });
  
              entry.target.addEventListener('pointerdown', () => {
                gtag('event', 'section_engaged', {
                  page_type: 'product_page',
                  section_name: sectionName,
                  product_id: productJSON.id,
                  product_handle: productJSON.handle,
                  product_title: productJSON.title,
                  product_url: `${window.location.origin}/products/${productJSON.handle}`,
                  timestamp: new Date().toISOString()
                });
              }, { once: true });
              
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.5 });
      
        productSections.forEach(section => {
          observer.observe(section);
        });
      });
  
    },
  
    async _fetchProductByHandle(handle) {
      try {
        const response = await fetch(`/products/${handle}.js`);
    
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
    
        const product = await response.json();
        return product;
      } catch (error) {
        return null;
      }
    },
  
    _attachPlyrVideoEvents(plyrInstance) {
      const self = this;
      const player = plyrInstance.player;
      if (player.config.autoplay) return;
  
      const video_url = plyrInstance.url;
      const progressPointsHit = {
        1: false,
        10: false,
        25: false,
        50: false,
        75: false,
        95: false
      };
  
      function onTimeUpdate(e) {
        if (!player.currentTime) return;
        
        const video_percent = (player.currentTime / player.duration) * 100;
        const visible = self._isElementInVisibility(player.elements.container);
        const muted = !player.volume || player.muted;
        let triggerEvent = false;
        let eventType = '';
        let eventData = {};
        
        for (const point of Object.keys(progressPointsHit)) {
          if (progressPointsHit[point]) continue;
          if (video_percent < parseInt(point)) break;
  
          Object.assign(eventData, {
            video_percent: point
          });
  
          if (point === '1') {
            eventType = 'video_start';
          } else if (point !== '1' && point !== '95') {
            eventType = 'video_progress';
          } else if (point === '95') {
            eventType = 'video_complete';
          }
  
          progressPointsHit[point] = true;
          triggerEvent = true;
          break;
        }
  
        if (triggerEvent) {
          Object.assign(eventData, {
            video_current_time: player.currentTime,
            video_duration: player.duration,
            video_provider: player.provider,
            video_title: player.config.title,
            video_url: plyrInstance.url,
            visible: visible,
            muted: muted
          });
          
          gtag('event', eventType, eventData);
        }
  
      }
      
      player.on('timeupdate', onTimeUpdate);
  
      return () => {
        player.off('timeupdate', onTimeUpdate);
      }
    }, 
    
    _isElementInVisibility(el) {
      const rect = el.getBoundingClientRect();
      const isHidden = (
        (rect.top < 0 && rect.bottom < 0) ||
        (rect.top - window.innerHeight > 0 && rect.bottom - window.innerHeight > 0)
      );
      
      return !isHidden;
    },
    
    _getPageType() {
      return window.ShopifyAnalyticsPageType;
    },
  
    _attachWishlistEvents() {
      window.SwymCallbacks.push((swat) => {
        swat.evtLayer.addEventListener('sw:addedtowishlist', (e) => {
          var data = e.detail.d;
          
          gtag('event', 'add_to_wishlist', {
            currency: Shopify.currency.active,
            value: data.pri,
            items: [{
              item_id: data.sku,
              item_name: data.dt,
              affiliation: "Shopify Store",
              item_brand: data.bt,
              item_variant: data.vi,
              item_sku: data.sku,
              price: data.pr,
              quantity: 1
            }]
          });
        });
  
        swat.evtLayer.addEventListener('sw:removedfromwishlist', (e) => {
          var data = e.detail.d;
          
          gtag('event', 'removed_from_wishlist', {
            currency: Shopify.currency.active,
            value: data.pr,
            items: [{
              item_id: data.sku,
              item_name: data.dt,
              affiliation: "Shopify Store",
              item_brand: data.bt,
              item_variant: data.vi,
              item_sku: data.sku,
              price: data.pr,
              quantity: 1
            }]
          });
        });
        
        swat.evtLayer.addEventListener('sw:addedtocart', (e) => {
          var data = e.detail.d.productData;	
          
          gtag('event', 'add_to_cart', {
            source: 'custom',
            form_id: 'wishlist',
            currency: Shopify.currency.active,
            value: data.cartLineItem.final_price,
            items: [{
              item_id: data.cartLineItem.sku,
              item_name: data.cartLineItem.product_title,
              affiliation: "Shopify Store",
              item_brand: data.cartLineItem.vendor,
              item_category: data.cartLineItem.product_type,
              item_variant: data.cartLineItem.variant_title,
              item_sku: data.cartLineItem.sku,
              price: data.cartLineItem.final_price,
              quantity: 1
            }]
          });
        });
        
      });
      
    },
  
    _attachScentSpaceEvents() {
      if (window.location.pathname != '/collections/scent-space') return;
  
      const mcMediaWithContent = document.querySelector('mc-media-with-content');
      if (!mcMediaWithContent) return;
      
      const readMore = mcMediaWithContent.querySelector('button[id*="Show-More"]');
      const tabs = mcMediaWithContent.querySelectorAll('[data-tabs]');
  
      //Check is customers are interested in the text
      readMore.addEventListener('click', () => {
        gtag('event', 'section_engaged', {
          page_type: 'collection_scent_space',
          section_name: 'media-with-content',
          action: 'read_more_clicked',
          page_url: window.location.href,
          timestamp: new Date().toISOString()
        });
      }, { once: true });
  
      //Check if customers are interested in the different categories
      tabs.forEach((t) => t.addEventListener('tabChange', (e) => {
        gtag('event', 'section_engaged', {
          page_type: 'collection_scent_space',
          section_name: 'media-with-content',
          action: 'tab_change',
          tab_id: e.detail.tabTogglers[0].dataset.tabId || '',
          page_url: window.location.href,
          timestamp: new Date().toISOString()
        });
      }));
  
      let engagementTimer = null;
      let timerCounter = 1;
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            engagementTimer = setInterval(() => {
              // console.log('ENGAGING SECTION, STAYED FOR: ' + (timerCounter * 5) + ' seconds')
              gtag('event', 'section_engaged', {
                page_type: 'collection_scent_space',
                section_name: 'media-with-content',
                engagement_timer: (timerCounter * 5000),
                page_url: window.location.href,
                timestamp: new Date().toISOString()
              });
              timerCounter++;
            }, 5000);
          } else {
            clearInterval(engagementTimer);
          }
        });
      }, {
        threshold: 0.5
      });
      observer.observe(mcMediaWithContent);
      
    }
    
  });
  
  window.analyticsEvents = new analyticsEvents();
  
  document.addEventListener('DOMContentLoaded', function() {
    window.analyticsEvents.init();
  });

})();